import { BRIEF_TASK_FORMS } from "@entities/brief/lib/constants";
import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ICampaignDeliverableTaskUpload } from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../../../brief/lib/services/briefConfigService";

export function useEditTaskContent(
  briefId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: editTaskContent,
    isLoading: isEditing,
    isSuccess: isEdited,
    variables,
  } = useMutation({
    mutationFn: ({ data }: { data: ICampaignDeliverableTaskUpload }) => {
      return BriefConfigService.editTaskContent(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },

    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, { data: { campaignInfluencerId } }) => {
      handleSuccess && handleSuccess();
      // c.invalidateQueries({
      //   queryKey: [
      //     ...BRIEF_CAMPAIGN_INFLUENCER_QUERY_KEY(
      //       campaignInfluencerId,
      //       data.data.briefInfluencerId
      //     ),
      //   ],
      // });
      c.invalidateQueries({
        queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_TASK_FORMS(briefId)],
      });
    },
  });

  return {
    editTaskContent,
    isEditing,
    isEdited,
    variables,
  };
}
